// extracted by mini-css-extract-plugin
export default {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","Photos__row":"sw_a bhr_a bhr_r bhr_j","Photos__img":"sw_b bhr_b"};